import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';

interface Props {
  size: number;
  color: string;
}

export default function PencilIcon({ size, color }: Props) {
  return (
    <DriveFileRenameOutlineIcon sx={{ fontSize: size, color }} />
  )
}
